import { stringOps } from './constants';

type StringOp = (typeof stringOps)[number];

export function isStringOp(op: string): op is StringOp {
  return stringOps.includes(op as StringOp);
}
